/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Visit_PackInputs */

const en_price_page_visit_pack = /** @type {(inputs: Price_Page_Visit_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pack of visits, cheaper per visit`)
};

const pl_price_page_visit_pack = /** @type {(inputs: Price_Page_Visit_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakiet wejść, taniej za wizytę`)
};

/**
* | output |
* | --- |
* | "A pack of visits, cheaper per visit" |
*
* @param {Price_Page_Visit_PackInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_visit_pack = /** @type {((inputs?: Price_Page_Visit_PackInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Visit_PackInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_visit_pack(inputs)
	return en_price_page_visit_pack(inputs)
});